import React from 'react';
import { connect } from 'react-redux';
import { withAdminLayout } from '../../common/admin-layout';
import { ADMIN_PAGES } from '../../assets/constants/global';
import { adminActions } from './admin-reducer';
import { BaseAdmin } from './base';
import { PROP_KEYS, ACTION_LOAD_TYPES, TEMPLATE_TYPES, ACTION_IMPORT_TYPES } from './admin-constants';

class AdminPaymentRules extends React.Component {
    componentDidMount() {
        const { loadData } = this.props;

        loadData();
    }

    render() {
        const { 
            paymentRules, paymentRulesErrorMsg, handleDataPageChange, handleDataPageSizeChange,
            paymentRulesPagination, isLoadedPaymentRules, importData, exportData,
            setImportedData, downloadTemplate, cleanDataErrorMsg, handleSort, paymentRuleColumnTypes
        } = this.props;
        const baseProps = {
            data: paymentRules,
            isLoaded: isLoadedPaymentRules,
            errorMsg: paymentRulesErrorMsg,
            handleImportData: importData,
            handleExportData: exportData,
            setImportedData: setImportedData,
            downloadTemplate: downloadTemplate,
            pagination: paymentRulesPagination,
            handlePageChange: handleDataPageChange,
            handlePageSizeChange: handleDataPageSizeChange,
            cleanErrorMsg: cleanDataErrorMsg,
            sortData: handleSort,
            columnTypes: paymentRuleColumnTypes
        };

        return (
            <BaseAdmin {...baseProps} />
        );
    }
}

const mapStateToProps = (state) => {
    const { admin } = state;
    const { paymentRules, paymentRulesPagination, isLoadedPaymentRules, paymentRulesErrorMsg, paymentRuleColumnTypes } = admin;

    return {
        paymentRules, isLoadedPaymentRules, paymentRulesPagination, paymentRulesErrorMsg, paymentRuleColumnTypes
    };
}

const { action, isLoadedKey, paginationKey, dataKey, importAction, importedKey, errorMsgKey, fileKey, columnTypesKey } = {
    action: ACTION_LOAD_TYPES.paymentRule,
    isLoadedKey: PROP_KEYS.isLoadedPaymentRules,
    paginationKey: PROP_KEYS.paymentRulesPagination,
    dataKey: PROP_KEYS.paymentRules,
    importAction: ACTION_IMPORT_TYPES.paymentRule,
    importedKey: PROP_KEYS.importedPaymentRules,
    errorMsgKey: PROP_KEYS.paymentRulesErrorMsg,
    fileKey: TEMPLATE_TYPES.AffiliatePaymentRule,
    columnTypesKey: PROP_KEYS.paymentRuleColumnTypes
}

const mapDispatchToProps = {
    loadData: () => adminActions.load({ 
        action, isLoadedKey, paginationKey, dataKey, fileKey, columnTypesKey
    }),
    importData: () => adminActions.importData({
        importAction, action, isLoadedKey, importedKey, errorMsgKey, paginationKey, dataKey
    }),
    exportData: () => adminActions.exportData({ 
        action, isLoadedKey, fileKey
    }),
    setImportedData: (file) => adminActions.setValue(importedKey, file),
    cleanDataErrorMsg: () => adminActions.setValue(errorMsgKey, []),
    downloadTemplate: () => adminActions.downloadTemplate({
        isLoadedKey, fileKey
    }),
    handleDataPageChange: (page, pageSize) => adminActions.handlePaginationChange(page, pageSize, { 
        action, isLoadedKey, paginationKey, dataKey, fileKey, columnTypesKey
    }),
    handleDataPageSizeChange: (_page, pageSize) => adminActions.handlePaginationChange(1, pageSize, { 
        action, isLoadedKey, paginationKey, dataKey, fileKey, columnTypesKey
    }),
    handleSort: (_pagination, _filters, sorter) => adminActions.handleSort(1, sorter, { 
        action, isLoadedKey, paginationKey, dataKey, fileKey, columnTypesKey
    })
}

const connectedAdminPaymentRules = connect(mapStateToProps, mapDispatchToProps)(withAdminLayout(AdminPaymentRules, ADMIN_PAGES.AdminPaymentRules));
export { connectedAdminPaymentRules as AdminPaymentRules };